







































































































import ActivityTimeline from '@/components/ActivityTimeline.vue';
import WeatherForecastSummary from '@/components/WeatherForecastSummary.vue';
import {
    GET_ACTIVITIES,
    GET_WEATHER_FORECAST,
    GET_WEATHER_LOCATION,
    IS_ACTIVITIES_LOADED,
    IS_HOMEY_GEO_COORDINATES_LOADED,
    IS_LOADING_ACTIVITIES,
    IS_LOADING_WEATHER_FORECAST,
    IS_LOADING_WEATHER_LOCATION,
    IS_WEATHER_FORECAST_LOADED,
    IS_WEATHER_LOCATION_LOADED
} from '@/store/getters.type';
import { Activity } from '@/types/activity';
import { GeolocationDetails } from '@/types/geolocation';
import { Weatherdata } from '@/types/weather';
import SettingsDialog from '@/views/SettingsDialog.vue';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
    components: {
        WeatherForecastSummary,
        SettingsDialog,
        ActivityTimeline
    }
})
export default class Dashboard extends Vue {
    @Getter(GET_WEATHER_LOCATION.getterName,
        {namespace: GET_WEATHER_LOCATION.namespace}) weatherLocation?: GeolocationDetails;
    @Getter(IS_LOADING_WEATHER_LOCATION.getterName,
        {namespace: IS_LOADING_WEATHER_LOCATION.namespace}) isLoadingWeatherLocation!: boolean;
    @Getter(IS_LOADING_WEATHER_FORECAST.getterName,
        {namespace: IS_LOADING_WEATHER_FORECAST.namespace}) isLoadingWeatherForecast!: boolean;
    @Getter(IS_WEATHER_FORECAST_LOADED.getterName,
        {namespace: IS_WEATHER_FORECAST_LOADED.namespace}) isWeatherForecastLoaded!: boolean;
    @Getter(GET_WEATHER_FORECAST.getterName,
        {namespace: GET_WEATHER_FORECAST.namespace}) weatherForecast?: Weatherdata;
    @Getter(IS_HOMEY_GEO_COORDINATES_LOADED.getterName,
        {namespace: IS_HOMEY_GEO_COORDINATES_LOADED.namespace}) isHomeyGeoCoordinatesLoaded!: boolean;
    @Getter(IS_WEATHER_LOCATION_LOADED.getterName,
        {namespace: IS_WEATHER_LOCATION_LOADED.namespace}) isWeatherLocationLoaded!: boolean;
    @Getter(GET_ACTIVITIES.getterName,
        {namespace: GET_ACTIVITIES.namespace}) activities!: Activity[];
    @Getter(IS_LOADING_ACTIVITIES.getterName,
        {namespace: IS_LOADING_ACTIVITIES.namespace}) isLoadingActivities!: boolean;
    @Getter(IS_ACTIVITIES_LOADED.getterName,
        {namespace: IS_ACTIVITIES_LOADED.namespace}) isActivitiesLoaded!: boolean;

    now: Date = new Date();

    created() {
        setInterval(() => {
            this.now = new Date();
        }, 1000 * 30); // every 30 seconds
    }

    get isRefreshingWeather(): boolean {
        return this.isLoadingWeatherLocation || this.isLoadingWeatherForecast;
    }

    get isWeatherLoaded(): boolean {
        return this.isWeatherForecastLoaded && this.isHomeyGeoCoordinatesLoaded && this.isWeatherLocationLoaded;
    }
}
